import React, { PureComponent } from 'react'
import Router from 'next/router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { store } from 'services'
import Button from 'controls/Button'


class PublishButton extends PureComponent {
  UNSAFE_componentWillReceiveProps(nextProps, _) {
    const {
      createPropertyData: { finished, error, response }
    } = nextProps
    if (this.props.createPropertyData.loading && finished && !error) {
      const id = response.id
      Router.push(
        {
          pathname: '/dashboard/properties/edit',
          query: { id: id }
        },
        {
          pathname: `/dashboard/properties/${id}/edit`
        }
      )
    }
  }

  createProperty = e => {
    e.preventDefault()
    this.props.actions.createProperty({
      broker: this.props.userId,
    })
  }

  render() {
    return (
      <Button fullWidth color="primary" onClick={this.createProperty}>
        Publicar
      </Button>
    )
  }
}

const mapStateToProps = state => ({
  createPropertyData: store.create('property').selector(state),
  userId: state.auth.profile.userId
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createProperty: store.create('property').action
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishButton)
